/**
 * The opening stage: the object, named.
 *
 * A product showcase earns attention by showing the product first and saying
 * what it is second, so this block is the artefact on its plinth, the name in
 * Michroma beside it, one line of positioning, and the spec band underneath.
 * There are no buttons — nothing here is for sale.
 *
 * Text-bearing nodes carry `data-rem-field` so editor >= 1.8.0 edits them
 * where they stand.
 */

import type { BlockRenderer } from '@remidus/web-core'

import { claimAnchor } from '../anchors'
import { paragraphs, plinth, resolveAll, specList } from './prose'

export const renderShowpiece: BlockRenderer = (block, ctx) => {
  const data = (block.data ?? {}) as {
    kicker?: string
    title?: string
    lede?: string
    media_id?: string
    media_ids?: string[] | string
    specs?: { label?: string; value?: string }[]
  }

  const stage = document.createElement('section')
  stage.className = 'skin-stage skin-stage--showpiece'
  claimAnchor(stage, data.title ?? 'The object', data.kicker)

  const field = document.createElement('div')
  field.className = 'skin-showpiece'

  const words = document.createElement('div')
  words.className = 'skin-showpiece__words'

  if (data.kicker) {
    const kicker = document.createElement('p')
    kicker.className = 'skin-kicker'
    kicker.textContent = data.kicker
    kicker.dataset.remField = 'kicker'
    words.append(kicker)
  }
  if (data.title) {
    const title = document.createElement('h2')
    title.className = 'skin-showpiece__title'
    title.textContent = data.title
    title.dataset.remField = 'title'
    words.append(title)
  }
  if (data.lede) {
    const lede = document.createElement('div')
    lede.className = 'skin-showpiece__lede'
    lede.dataset.remField = 'lede'
    lede.setAttribute('data-rem-field-multiline', '')
    paragraphs(lede, data.lede)
    words.append(lede)
  }

  field.append(words)

  const shot = plinth(resolveAll(data, ctx)[0], 'skin-plinth--hero')
  if (shot) field.append(shot)

  stage.append(field)

  const specs = specList(data.specs, 'specs')
  if (specs) stage.append(specs)

  return stage
}
